import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from 'lib/api'
import { errorWrap } from 'lib/saga-helpers'
import { constants } from './actions'

function * fetchStats () {
  const { data: stats } = yield call(api.get, '/stats')
  yield put({
    type: constants.FETCH_STATS_SUCCESS,
    payload: stats
  })
}

function * fetchSubjectCoverage () {
  const { data: subjectCoverage } = yield call(api.get, '/stats/subject-coverage')
  yield put({
    type: constants.FETCH_SUBJECT_COVERAGE_SUCCESS,
    payload: subjectCoverage
  })
}

export default function * rootSaga () {
  yield takeLatest(constants.FETCH_STATS, errorWrap(fetchStats, constants.FETCH_STATS_FAILURE))
  yield takeLatest(constants.FETCH_SUBJECT_COVERAGE, errorWrap(fetchSubjectCoverage, constants.FETCH_SUBJECT_COVERAGE_FAILURE))
}
